$(() => {
    // CTA button on Contractor Search block
	$('.contractor-search .form-container a').on('click', event => {
        event.preventDefault()

        let anchor = $(event.target).closest('a')
        let baseUrl = anchor.attr('href')
		let form = $(event.target).closest('.form-container')
        let service = form.find('select[name="type"]').val()
        let state = form.find('select[name="state"]').val()

        let url = new URL(baseUrl, document.baseURI)
        if (service) url.searchParams.append('service', service)
        if (state) url.searchParams.append('state', state)

        window.location.href = url.href
	})

    // CTA button in mega menu Contractor widget
	$('.submenu .footer .widget .form-container a').on('click', event => {
        event.preventDefault()

        let anchor = $(event.target).closest('a')
        let baseUrl = anchor.attr('href')
		let form = $(event.target).closest('.form-container')
        let service = form.find('select[name="type"]').val()
        let state = form.find('select[name="state"]').val()

        let url = new URL(baseUrl, document.baseURI)
        if (service) url.searchParams.append('service', service)
        if (state) url.searchParams.append('state', state)

        window.location.href = url.href
	})
})